document.addEventListener("DOMContentLoaded", () => {

  // Elementos generales a animar
  const baseSel = ".shopify-section,.card,.multicolumn-card,.image-with-text,.rich-text,.collection-list,.product-grid,.newsletter,.slideshow__text-wrapper";
  document.querySelectorAll(baseSel).forEach(el => el.classList.add("reveal"));

  // Stagger por grillas (reinicia por sección)
  document.querySelectorAll(".product-grid,.collection-list,.multicolumn-list").forEach(grid => {
    [...grid.querySelectorAll(".grid__item,.multicolumn-list__item")].forEach((el,i) => {
      el.style.setProperty("--i", i % 12);
      el.classList.add("reveal");
    });
  });

  // Observer
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add("reveal--in");
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -10% 0px" });

  document.querySelectorAll(".reveal").forEach(el => io.observe(el));

});
